import React from 'react';
import ReactDOM from 'react-dom/client';
import App from '@/App';
import '@/index.css';

import { ThemeProvider } from "@/components/ThemeProvider";

// --- ПОЧАТОК ІНТЕГРОВАНОГО КОДУ SERVICE WORKER ---
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(reg => console.log('SW reg ok', reg))
      .catch(err => console.warn('SW reg failed', err));
  });
}
// --- КІНЕЦЬ ІНТЕГРОВАНОГО КОДУ SERVICE WORKER ---

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);